import { render } from "./SmallAvatar.vue?vue&type=template&id=65ae2950&scoped=true"
import script from "./SmallAvatar.vue?vue&type=script&lang=js"
export * from "./SmallAvatar.vue?vue&type=script&lang=js"

import "./SmallAvatar.vue?vue&type=style&index=0&id=65ae2950&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ae2950"]])

export default __exports__